module.exports = __webpack_public_path__ + "3a4f0d868f98102451203eceb2bf191a.MP3";